import isEmpty from 'lodash/isEmpty'

export default function extractFullColorNumber (colorObj = {}, withSpace = false) {
  if (isEmpty(colorObj)) return
  return `${colorObj.brandKey}${withSpace ? ' ' : ''}${colorObj.colorNumber}`
}
